import { Link2 } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgHyperlink2 = mkIcon(Link2);